module.exports = "/call-frontend/img/icon_cancel_outline.b0fe9133.svg";